import { CmsComponentMapping } from '@domgen/dgx-fe-cms';
import {
  ErrorComponent,
  ErrorPageContentBlockComponent,
} from '@error/feature-error';

export const ERROR_CMS_COMPONENT_MAPPING: CmsComponentMapping = {
  'dgx-error:pages/error': ErrorComponent,
  'dgx-error:components/error-page-content-block':
    ErrorPageContentBlockComponent,
};
